import { constants } from '../constant/constant';
import { httpservice } from '../services';
import { SYSTEM_EVENT } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';

const getSystemEventList = (obj) => (dispatch) => {
  const query = `${constants.API.GET_SYSTEM_EVENTS}?page=${obj.page}&size=${obj.size}`;
  dispatch({
    payload: [],
    type: SYSTEM_EVENT.DATA.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      const rows = response.data.response.data.events;
      const count = response.data.response.data.totalItems;
      const responseData = rows.map((data) => (
        {
          ...data,
          created_at: dateFormat(data.createdAt),
          created_by: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'N/A',
        }
      ));

      dispatch({
        payload: { data: responseData, count },
        type: SYSTEM_EVENT.DATA.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SYSTEM_EVENT.DATA.ERROR,
      });
    });
};

export default getSystemEventList;
